var _path, _path2, _path3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRacqFavicon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 22,
    viewBox: "0 0 56 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.9102 0.000382267C12.6408 -0.0140441 14.351 0.380039 15.9033 1.15175C17.4557 1.9236 18.8081 3.05143 19.8506 4.44472L28.1562 14.3988C31.0458 17.7779 34.9762 19.5448 38.8789 18.7767C36.0504 21.0602 32.5035 21.9994 28.0625 21.9994C22.5121 21.9994 18.3662 20.5349 15.2676 16.8207L5.66504 5.30995C4.04941 3.26548 2.13999 1.47598 0 0.000382267H10.9102Z",
    fill: "#003478"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.411 18.141C32.7483 20.9186 28.4163 17.2447 25.5735 13.9077L17.5777 4.30029C16.5778 2.956 15.2793 1.86679 13.7864 1.12003C12.2935 0.373278 10.6479 -0.0102139 8.98145 0.000316754H12.5129C14.1797 -0.0126024 15.8262 0.36984 17.3194 1.11678C18.8127 1.86373 20.1108 2.95423 21.1091 4.30029L29.1049 13.9077C30.2885 15.4803 31.8698 16.7031 33.683 17.4478C35.4961 18.1926 37.4745 18.432 39.411 18.141Z",
    fill: "url(#paint0_linear_15925_21955)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M42.0075 15.4367L50.5581 5.15712C52.1113 3.18626 53.9449 1.45776 55.9995 0.0276605H45.4934C43.8265 0.0147413 42.18 0.397184 40.6868 1.14413C39.1935 1.89107 37.8954 2.98159 36.8971 4.32764L29.79 12.8831C32.9685 16.619 39.0985 18.9025 42.0075 15.4367Z",
    fill: "url(#paint1_linear_15925_21955)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_15925_21955",
    x1: 24.1962,
    y1: 0.0191207,
    x2: 24.1962,
    y2: 19.1207,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E98300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#EF9F00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.221,
    stopColor: "#F5B900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.356,
    stopColor: "#F9CD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.508,
    stopColor: "#FDDB00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.693,
    stopColor: "#FEE300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE600"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_15925_21955",
    x1: 42.8948,
    y1: 17.1473,
    x2: 42.8948,
    y2: 0.0273438,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E98300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#EF9F00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.221,
    stopColor: "#F5B900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.356,
    stopColor: "#F9CD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.508,
    stopColor: "#FDDB00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.693,
    stopColor: "#FEE300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE600"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRacqFavicon);
export default __webpack_public_path__ + "static/media/RACQ Favicon.2b1a82a040371208b5d75b11d4948077.svg";
export { ForwardRef as ReactComponent };